import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from 'react-bootstrap-myui/lib/Input'

class Radiobox extends React.Component {
  static propTypes = {
    data: PropTypes.any, // bool
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
  };

  constructor(props) {
    super(props)
    this.state = {
      checked: props.data || false,
      data: props.data,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      this.setState({
        checked: nextProps.data || false
      })
    }
  }

  render() {
    const { checked, data } = this.state
    const { name, options } = this.props
    if (Array.isArray(options) && options.length > 0) {
      return (
        <div style={{ textAlign: 'left' }} className="checkbox-container">
          {
            options.map(d => (
              <div className="col-xs-6" key={d.value}>
                <Input
                  label={d.label}
                  type="radio"
                  name={ name || 'radio'}
                  checked={d.value === data}
                  onClick={this.handleCheckChangeData.bind(this, d.value)}
                  onChange={() => { }}
                />
              </div>
            ))
          }
        </div>
      )
    }
    return (
      <div style={{ textAlign: 'left' }} className="checkbox-container">
        <div className="col-xs-6">
          <Input
            label="显示"
            type="radio"
            name={ name || 'radio'}
            checked={checked}
            onClick={this.handleCheckChange.bind(this, !checked)}
            onChange={() => { }}
          />
        </div>
        <div className="col-xs-6">
          <Input
            label="不显示"
            type="radio"
            name={ name || 'radio'}
            checked={!checked}
            onClick={this.handleCheckChange.bind(this, !checked)}
            onChange={() => { }}
          />
        </div>
      </div>
    )
  }

  handleCheckChange(value) {
    this.setState({
      checked: value
    }, () => {
      this.props.onChange(value)
    })
  }

  handleCheckChangeData(value) {
    this.setState({
      data: value
    }, () => {
      this.props.onChange(value)
    })
  }
}

export default Radiobox
